import { useNavigate } from 'react-router-dom';
import { useCommandModel } from 'utils/hooks/useCommandModel';
import { useNotifications } from 'utils/hooks/useNotifications';
import { queryClient } from 'utils/react-query/queryClient';
import { useApi } from 'utils/request/useApi';
import {
  type IpfCertificateModel,
  createInitialIpfCertificateState,
} from './IpfCertificateModel';

export const useIpfCertificate = (): IpfCertificateModel => {
  const navigate = useNavigate();
  const model = useCommandModel(
    createInitialIpfCertificateState,
    {
      api: useApi(),
      showNotification: useNotifications().showNotification,
      navigate,
      queryClient,
    },
    {},
  );

  return model;
};
